module.exports = "/img/purpleblue_background.9314a662.jpg";